module.exports = __webpack_public_path__ + "img/surfing10classic_bg.f503314c.png";